import React from "react";
import PropTypes from "prop-types";
import PostInspectionDiyVideoWrapper from "../post-inspection-diy-video-wrapper";

const PostInspectionDiyVideoSteps = ({
    heading,
    helperVideos = []
}) => {

    return (
        <PostInspectionDiyVideoWrapper
            heading={heading}
            helperVideos={helperVideos}
        />
    );
};

PostInspectionDiyVideoSteps.propTypes = {
    heading: PropTypes.string,
    helperVideos: PropTypes.array
};

export default PostInspectionDiyVideoSteps;
